// src/App.js - Main Kiosk Application
import React, { useState, useEffect } from 'react';
import './App.css';
import WelcomeScreen from './components/WelcomeScreen';
import MenuScreen from './components/MenuScreen';
import OrderScreen from './components/OrderScreen';
import { KioskProvider } from './context/KioskContext';

function App() {
  const [currentScreen, setCurrentScreen] = useState('welcome');
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    // Auto-fullscreen for kiosk mode
    const enterFullscreen = () => {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
        setIsFullscreen(true);
      }
    };

    // Uncomment for production kiosk
    // enterFullscreen();
  }, []);

  const renderScreen = () => {
    switch (currentScreen) {
      case 'welcome':
        return <WelcomeScreen onNext={() => setCurrentScreen('menu')} />;
      case 'menu':
        return <MenuScreen onNext={() => setCurrentScreen('order')} />;
      case 'order':
        return <OrderScreen onHome={() => setCurrentScreen('welcome')} />;
      default:
        return <WelcomeScreen onNext={() => setCurrentScreen('menu')} />;
    }
  };

  return (
    <KioskProvider>
      <div className="App kiosk-container">
        {renderScreen()}
      </div>
    </KioskProvider>
  );
}

export default App;